module.exports = __webpack_public_path__ + "static/media/18.fc1506a5.JPG";